import * as React from 'react';
import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { AvoidWidowText } from 'shared-react';
import { colors, combineStyles, media, mixins } from 'consumer-components';
import * as IconButtonStyles from 'login-stylesheets/IconButton';
import * as deploymentConfig from 'login-utils/deploymentConfig';

const styles = StyleSheet.create({
  BorderlessIconButton: {
    ...mixins.marginVertical(8),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: 'none',
    borderRadius: 10,
    backgroundColor: colors.white,
    transition: 'background 0.2s ease-out',
    outline: 'none', // TODO (UI-5035): remove this once we hide outlines by default across the app
    [media.smallView]: {
      ...mixins.paddingHorizontal(0),
    },
  },
  selectable: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: mixins.fade(deploymentConfig.getOrganizationColors().action, 0.07),
    },
  },
  textWrapper: combineStyles(IconButtonStyles.textWrapper, {
    flexGrow: 1,
    [media.mobileMedium]: {
      marginLeft: 8,
    },
  }),
  buttonText: IconButtonStyles.buttonText,
});

interface BorderlessIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  IconComponent: React.ComponentType;
  text: string;
  buttonId: string;
  selectable?: boolean;
}

export interface BorderlessIconButtonConfig extends BorderlessIconButtonProps {
  value: string;
}

export default class BorderlessIconButton extends React.Component<BorderlessIconButtonProps> {
  render() {
    const { text, IconComponent, buttonId, selectable = true, onClick, ...buttonProps } = this.props;

    return (
      <button
        id={buttonId}
        className={css(styles.BorderlessIconButton, selectable && styles.selectable)}
        {...buttonProps}
        onClick={selectable ? onClick : _.noop}
      >
        <IconComponent />
        <div className={css(styles.textWrapper)}>
          <h2 className={css(styles.buttonText)}>
            <AvoidWidowText text={text} />
          </h2>
        </div>
      </button>
    );
  }
}
